import { useEffect } from 'react';
import useScript from 'react-script-hook';
import { useBusiness } from 'hooks/business/use-business';
import { useUser } from 'hooks/auth/use-user';

const HUBSPOT_SCRIPT_URL = '//js-na2.hs-scripts.com/19841239.js';

const runWhenHubSpotReady = (callback: () => void) => {
  if (window.HubSpotConversations) {
    callback();
    return;
  }

  window.hsConversationsOnReady = window.hsConversationsOnReady ?? [];
  window.hsConversationsOnReady.push(callback);
};

export const HubspotTrackingCode = () => {
  const { data: business } = useBusiness();
  const { data: user } = useUser(business?.Id);

  const [loading] = useScript({
    async: true,
    checkForExisting: true,
    defer: true,
    id: 'hs-script-loader',
    src: HUBSPOT_SCRIPT_URL,
  });

  useEffect(() => {
    if (loading) {
      return;
    }

    let cancelled = false;

    runWhenHubSpotReady(() => {
      if (cancelled) {
        return;
      }

      window.HubSpotConversations?.widget?.load?.();

      if (user?.email) {
        const _hsq = window._hsq ?? [];
        _hsq.push(['identify', { email: user.email }]);
      }
    });

    return () => {
      cancelled = true;
    };
  }, [loading, user?.email]);

  useEffect(
    () => () => {
      window.HubSpotConversations?.widget?.remove?.();
    },
    [],
  );

  return null;
};
